var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaulaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    fill: "#fff",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.575,43.772c-0.875-2.341-2.07-4.548-3.525-6.589l-7.656-2.018c-1.148-0.303-2.33-0.456-3.516-0.456  c-3.545,0-6.861,1.367-9.339,3.844c-2.683,2.682-6.243,4.157-10.029,4.157c-3.788,0-7.347-1.475-10.024-4.153  c-3.071-3.076-4.372-7.217-4.027-11.244c-7.003,3.623-12.417,9.457-15.034,16.458C13.569,44.983,10,48.782,10,53.332  c0,4.551,3.569,8.35,8.424,9.561C22.865,74.768,35.309,83.332,50,83.332c14.688,0,27.136-8.564,31.575-20.439  C86.426,61.682,90,57.883,90,53.332C90,48.782,86.426,44.983,81.575,43.772z M33.333,53.332c0-1.842,1.492-3.333,3.333-3.333  S40,51.49,40,53.332c0,1.843-1.493,3.334-3.333,3.334S33.333,55.175,33.333,53.332z M36.667,67.805l3.537-3.535  c2.617,2.621,6.095,4.063,9.796,4.063c3.698,0,7.181-1.441,9.798-4.063l3.535,3.535C55.97,75.175,44.028,75.175,36.667,67.805z   M63.333,56.666c-1.842,0-3.333-1.491-3.333-3.334C60,51.49,61.491,50,63.333,50c1.843,0,3.334,1.491,3.334,3.333  C66.667,55.175,65.176,56.666,63.333,56.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.001,35.022c-3.584,3.584-9.396,3.584-12.979,0c-3.584-3.587-3.584-9.395,0-12.979c7.168-7.168,18.79-7.168,25.954,0  c2.373,2.37,3.891,5.257,4.691,8.288C65.554,28.72,58.786,30.23,54.001,35.022z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaulaIcon);
export default __webpack_public_path__ + "static/media/ChaulaIcon.45caa128dcf2bb9734d0251c83a38213.svg";
export { ForwardRef as ReactComponent };